import * as React from 'react';
import {isAnySelected, TableState} from './redux/actions';
import IconButton from '@material-ui/core/IconButton';
import {IconButtonProps} from '@material-ui/core/IconButton/IconButton';
import {TableContext} from './redux/createTableContext';
import withTable from './redux/withTable';
import ClearIcon from '@material-ui/icons/Clear';

type TableContextProps = 'onToggleSelectAll';
type TableStateProps = 'selection' | 'count';

type TableFilterButtonProps = Pick<TableContext, TableContextProps> &
  Pick<TableState, TableStateProps> &
  IconButtonProps;

const ClearSelectionButton: React.SFC<TableFilterButtonProps> = ({selection, count, onToggleSelectAll}) => {
  if (isAnySelected({selection, count}))
    return (
      <IconButton id="cla-btn-clear-selection" onClick={onToggleSelectAll}>
        <ClearIcon />
      </IconButton>
    );
};

export default withTable<TableContextProps | TableStateProps>({props: ['selection', 'count', 'onToggleSelectAll']})(
  ClearSelectionButton
);
